/* GOLDSQUARE COFFEE - THEME JS

   Rewritten. What was wrong before:
     - renderCartFromShopify() hand-built cart HTML as innerHTML
       strings, so drawer and cart page could drift apart.
     - moneyFormat() hardcoded a rupee sign + toFixed(0).
     - The reviews block targeted #reviewCards / #aggBar /
       #reviewCount / #rName / #rCity / #rProduct / #rText while the
       markup used #reviewsFeed / #aggBars / #aggCount / #rfName /
       #rfCity / #rfProduct / #rfText - every id mismatched, so the
       feed never rendered and the form always errored. That block
       was fabricated data and has been removed entirely.
     - toggleNav(), closeMobileNav() and openModal('accountModal')
       were called but never defined.

   Everything now hangs off a single GS namespace so inline
   onclick handlers in Liquid have one stable entry point.
*/

(function () {
  'use strict';

  var GS = window.GS = {};

  /* --- Money -------------------------------------------------
     Uses the shop's own money format rather than assuming rupees
     with no decimals. */

  function getMoneyFormat() {
    var el = document.querySelector('[data-money-format]');
    return el ? el.getAttribute('data-money-format') : null;
  }

  GS.money = function (cents) {
    var amount = cents / 100;
    var fmt = getMoneyFormat();
    if (fmt && fmt.indexOf('{{') !== -1) {
      var withComma = amount.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      var noDecimals = Math.round(amount).toLocaleString('en-IN');
      return fmt
        .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, noDecimals)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDecimals)
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withComma)
        .replace(/\{\{\s*amount\s*\}\}/g, withComma);
    }
    try {
      return new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', maximumFractionDigits: 0 }).format(amount);
    } catch (e) {
      return '₹' + Math.round(amount);
    }
  };

  /* --- Cart drawer, via the Section Rendering API -------------
     Re-fetching the Liquid section keeps drawer markup, the cart
     page and money formatting in one place instead of duplicating
     them in JS strings. */

  function drawerEl() { return document.getElementById('cartDrawer'); }

  GS.refreshCart = function () {
    return fetch('/?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var wrapper = document.createElement('div');
        wrapper.innerHTML = html;
        var fresh = wrapper.querySelector('#cartDrawer');
        var current = drawerEl();
        if (!fresh || !current) return;

        var wasOpen = current.classList.contains('open');
        current.innerHTML = fresh.innerHTML;
        current.setAttribute('data-item-count', fresh.getAttribute('data-item-count'));
        if (wasOpen) current.classList.add('open');

        var count = parseInt(fresh.getAttribute('data-item-count'), 10) || 0;
        var counters = document.querySelectorAll('#cartCount');
        for (var i = 0; i < counters.length; i++) counters[i].textContent = count;
      })
      .catch(function (err) { console.error('[GS] cart refresh failed', err); });
  };

  GS.openCart = function () {
    var d = drawerEl();
    if (!d) return;
    d.classList.add('open');
    var o = document.getElementById('overlay');
    if (o) o.classList.add('open');
    document.body.style.overflow = 'hidden';
    GS.refreshCart();
  };

  GS.closeCart = function () {
    var d = drawerEl();
    if (d) d.classList.remove('open');
    if (!document.querySelector('.modal.open')) {
      var o = document.getElementById('overlay');
      if (o) o.classList.remove('open');
      document.body.style.overflow = '';
    }
  };

  GS.closeAll = function () {
    var modals = document.querySelectorAll('.modal.open');
    for (var i = 0; i < modals.length; i++) modals[i].classList.remove('open');
    var o = document.getElementById('overlay');
    if (o) o.classList.remove('open');
    document.body.style.overflow = '';
    GS.closeCart();
  };

  function showCartError(msg) {
    var box = document.getElementById('cartError');
    if (box) { box.textContent = msg; box.hidden = false; }
    else { console.error('[GS]', msg); }
  }

  /* --- Add to cart -------------------------------------------
     Guards against the old failure mode: the previous build passed
     `variants.first.id | default: 0` and cheerfully POSTed id 0
     whenever a product did not exist. */

  GS.addToCart = function (variantId, quantity, btn) {
    if (!variantId || variantId === 0 || variantId === '0') {
      console.error('[GS] refusing to add invalid variant id:', variantId);
      GS.openCart();
      showCartError('This product is unavailable right now.');
      return;
    }

    var original = btn ? btn.textContent : null;
    if (btn) { btn.disabled = true; btn.textContent = 'Adding...'; }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity || 1 })
    })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) throw new Error(data.description || data.message || 'Could not add to cart');
          return data;
        });
      })
      .then(function () { return GS.refreshCart(); })
      .then(function () { GS.openCart(); })
      .catch(function (err) {
        console.error('[GS] add to cart failed', err);
        GS.openCart();
        showCartError(err.message);
      })
      .then(function () {
        if (btn) { btn.disabled = false; btn.textContent = original; }
      });
  };

  GS.changeLine = function (line, quantity) {
    var d = drawerEl();
    if (d) d.classList.add('drawer-loading');
    var onCartPage = document.body.className.indexOf('template-cart') !== -1;

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (res) { return res.json(); })
      .then(function () {
        if (onCartPage) { window.location.reload(); return; }
        return GS.refreshCart();
      })
      .catch(function (err) {
        console.error('[GS] cart update failed', err);
        showCartError('Could not update your cart. Please try again.');
      })
      .then(function () { if (d) d.classList.remove('drawer-loading'); });
  };

  /* --- Product page ------------------------------------------ */

  GS.selectPack = function (btn) {
    var group = btn.parentElement;
    var opts = group.querySelectorAll('.pack-opt');
    for (var i = 0; i < opts.length; i++) {
      opts[i].classList.remove('selected');
      opts[i].setAttribute('aria-checked', 'false');
    }
    btn.classList.add('selected');
    btn.setAttribute('aria-checked', 'true');

    var price   = parseInt(btn.getAttribute('data-price'), 10);
    var compare = parseInt(btn.getAttribute('data-compare'), 10);
    var save    = parseInt(btn.getAttribute('data-save'), 10);

    var idInput = document.getElementById('pdpVariantId');
    if (idInput) idInput.value = btn.getAttribute('data-variant-id');

    var priceEl = document.getElementById('pdpPriceMain');
    if (priceEl) priceEl.textContent = GS.money(price);

    var compEl = document.getElementById('pdpPriceCompare');
    if (compEl) {
      if (compare > price) { compEl.textContent = GS.money(compare); compEl.hidden = false; }
      else { compEl.hidden = true; }
    }

    var saveEl = document.getElementById('pdpSave');
    if (saveEl) {
      if (save > 0) { saveEl.textContent = 'Save ' + save + '%'; saveEl.hidden = false; }
      else { saveEl.hidden = true; }
    }

    var atc = document.getElementById('pdpAtc');
    if (atc) {
      var available = btn.getAttribute('data-available') === 'true';
      atc.disabled = !available;
      atc.textContent = available ? 'Add to Cart' : 'Sold Out';
    }

    if (window.history && window.history.replaceState) {
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', btn.getAttribute('data-variant-id'));
        window.history.replaceState({}, '', url);
      } catch (e) { /* older browsers - harmless */ }
    }
  };

  GS.stepQty = function (btn, delta) {
    var el = btn.parentElement.querySelector('.qty-num');
    if (!el) return;
    var val = Math.max(1, (parseInt(el.textContent, 10) || 1) + delta);
    el.textContent = val;
    var input = document.getElementById('pdpQtyInput');
    if (input) input.value = val;
  };

  GS.swapImage = function (btn, src) {
    var main = document.querySelector('#pdpMainImg img');
    if (main) { main.src = src; main.srcset = ''; }
    var thumbs = document.querySelectorAll('.pdp-thumb');
    for (var i = 0; i < thumbs.length; i++) thumbs[i].classList.remove('active');
    btn.classList.add('active');
  };

  GS.toggleAcc = function (btn) {
    var item = btn.closest('.acc-item');
    if (!item) return;
    var panel = item.querySelector('.acc-a');
    var isOpen = item.classList.contains('open');
    var wrap = item.closest('.acc') || document;

    var open = wrap.querySelectorAll('.acc-item.open');
    for (var i = 0; i < open.length; i++) {
      open[i].classList.remove('open');
      open[i].querySelector('.acc-a').style.maxHeight = '0';
      open[i].querySelector('.acc-q').setAttribute('aria-expanded', 'false');
    }

    if (!isOpen) {
      item.classList.add('open');
      panel.style.maxHeight = panel.scrollHeight + 'px';
      btn.setAttribute('aria-expanded', 'true');
    }
  };

  GS.sortCollection = function (select) {
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', select.value);
    url.searchParams.delete('page');
    window.location.href = url.toString();
  };

  /* --- Navigation --------------------------------------------
     toggleNav / closeMobileNav were called from markup but never
     existed, throwing on every mobile menu tap. */

  GS.toggleNav = function () {
    var nav = document.getElementById('mobileNav');
    var btn = document.getElementById('hamburger');
    if (!nav) return;
    var isHidden = nav.hasAttribute('hidden');
    if (isHidden) { nav.removeAttribute('hidden'); }
    else { nav.setAttribute('hidden', ''); }
    if (btn) btn.setAttribute('aria-expanded', String(isHidden));
  };

  GS.smoothTo = function (id) {
    var el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  GS.openModal = function (id) {
    var modal = document.getElementById(id);
    if (!modal) { console.warn('[GS] no modal:', id); return; }
    GS.closeCart();
    var o = document.getElementById('overlay');
    if (o) o.classList.add('open');
    modal.classList.add('open');
    document.body.style.overflow = 'hidden';
  };

  GS.closeModal = function (id) {
    var modal = document.getElementById(id);
    if (modal) modal.classList.remove('open');
    if (!document.querySelector('.modal.open')) {
      var o = document.getElementById('overlay');
      if (o) o.classList.remove('open');
      document.body.style.overflow = '';
    }
  };

  /* --- Scroll behaviour --------------------------------------- */

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('in-view'); observer.unobserve(e.target); }
    });
  }, { threshold: 0.12 });

  /* --- Init --------------------------------------------------- */

  document.addEventListener('DOMContentLoaded', function () {
    var animated = document.querySelectorAll('.fade-up, .fade-left, .fade-right');
    for (var i = 0; i < animated.length; i++) observer.observe(animated[i]);

    var header = document.getElementById('siteHeader');
    if (header) {
      window.addEventListener('scroll', function () {
        header.classList.toggle('scrolled', window.scrollY > 10);
      }, { passive: true });
    }

    var stickyBar = document.getElementById('stickyBar');
    var hero = document.querySelector('.hero');
    if (stickyBar && hero) {
      new IntersectionObserver(function (entries) {
        stickyBar.classList.toggle('visible', !entries[0].isIntersecting);
      }, { threshold: 0 }).observe(hero);
    }

    // Product form -> AJAX add, so the drawer opens instead of a page jump
    var pdpForm = document.getElementById('pdpForm');
    if (pdpForm) {
      pdpForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var id = document.getElementById('pdpVariantId').value;
        var qty = parseInt(document.getElementById('pdpQtyInput').value, 10) || 1;
        GS.addToCart(parseInt(id, 10), qty, document.getElementById('pdpAtc'));
      });
    }

    GS.refreshCart();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') GS.closeAll();
  });

  /* --- Back-compat shims -------------------------------------
     Any Liquid still carrying the old inline handlers keeps working
     rather than throwing ReferenceError. */
  window.openCartDrawer  = GS.openCart;
  window.closeCartDrawer = GS.closeCart;
  window.closeAllModals  = GS.closeAll;
  window.openModal       = GS.openModal;
  window.closeModal      = GS.closeModal;
  window.toggleNav       = GS.toggleNav;
  window.toggleMobileNav = GS.toggleNav;
  window.closeMobileNav  = GS.toggleNav;
  window.smoothTo        = GS.smoothTo;
  window.toggleFaq       = GS.toggleAcc;
  window.handleCheckout  = function () { window.location.href = '/checkout'; };
})();
